"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _system = require("@mui/system");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var SvgIconRoot = (0, _system.styled)('svg')(function (_ref) {
  var ownerState = _ref.ownerState;
  var fontSize = ownerState.fontSize,
    color = ownerState.color,
    _ownerState$width = ownerState.width,
    width = _ownerState$width === void 0 ? '1em' : _ownerState$width,
    _ownerState$height = ownerState.height,
    height = _ownerState$height === void 0 ? '1em' : _ownerState$height;
  return {
    userSelect: 'none',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    fontSize: fontSize,
    color: color,
    width: width,
    height: height
  };
});
var SvgIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    classes = props.classes,
    _props$color = props.color,
    color = _props$color === void 0 ? 'inherit' : _props$color,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 'inherit' : _props$fontSize,
    width = props.width,
    height = props.height,
    other = __rest(props, ["children", "className", "classes", "color", "fontSize", "width", "height"]);
  var ownerState = {
    color: color,
    fontSize: fontSize,
    width: width,
    height: height
  };
  return /*#__PURE__*/React.createElement(SvgIconRoot, Object.assign({
    ownerState: ownerState,
    ref: ref,
    className: (0, _clsx["default"])(classes, className)
  }, other), children);
});
exports.SvgIcon = SvgIcon;